import React from 'react'
import {
  Show,
  TextField,
  DateField,
  ArrayField,
  Datagrid,
  BooleanField,
  FunctionField,
} from 'react-admin';
import { Chip, Box } from '@mui/material';
import NestedReferenceField from '../../components/NestedReferenceField';

const UserInviteShow = (props) => {
  return (
    <Show {...props} title="Invitation Details">
      <Box display="flex" flexDirection="column" gap={2} padding={2}>
        <TextField source="id" label="ID" />
        <NestedReferenceField source="inviting_user" labelField="email" resource="users" label="Invited by" />
        <NestedReferenceField source="invited_user" labelField="email" resource="users" label="Invited user" />
        <FunctionField
          label="Status"
          render={record =>
            record.acceptation_date
              ? <Chip label="Accepted" color="success" size="small" />
              : <Chip label="Pending" color="warning" size="small" />
          }
        />
        <DateField source="acceptation_date" label="Accepted at" showTime />
        <DateField source="creation_date" label="Sent at" showTime />

        <ArrayField source="user_in_organisations">
          <Datagrid bulkActionButtons={false}>
            <NestedReferenceField source="organisation" labelField="name" resource="organisations" label="Organisation" />
            <TextField source="type" label="Role" />
            <BooleanField source="accepted" />
          </Datagrid>
        </ArrayField>

        <ArrayField source="user_in_teams">
          <Datagrid bulkActionButtons={false}>
            <NestedReferenceField source="team" labelField="name" resource="teams" label="Team" />
            <BooleanField source="accepted" />
          </Datagrid>
        </ArrayField>

        <ArrayField source="user_in_vet_cases">
          <Datagrid bulkActionButtons={false}>
            <NestedReferenceField source="vet_case" labelField="id" resource="vet_cases" label="Vet case" />
          </Datagrid>
        </ArrayField>
      </Box>
    </Show>
  );
};

export default UserInviteShow;
